import "../JSONTools/JSONformatter.css";
import ToolHeader from "../../Components/ToolHeader";
import { ToolModeToggle } from "../../Components/ToolActionButtons";
import { Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import { ASCIIDecode, ASCIIEncode } from "../../Services/APIService";
import FormatterPanel from "../../HomePage/FormatterPanel";
import { InputHeaderButtons, OutputHeaderButtons } from "../JSONTools/JSONToolsHeaderButtons";


function AsciiEncoder() {
    const [text, setText] = useState("");
    const [result, setresult] = useState("")
    const toolFav = { toolName: 'ASCII Bytes Converter', Iconpath: "/binary.svg" };
    const [mode, setMode] = useState("encode");


    


    useEffect(() => {
        setText("")
        setresult("")
    }, [mode]);

    



    const lineCount = (text || "").split("\n").length;
    const resultLineCount = (result ?? "").toString().split("\n").length;

    const handleChange = async (e) => {
        const value = e.target.value;
        setText(value);
    };

    const Execute = async () => {
        if(text.trim() === "") {
            setresult("");
            return;
        }
        getResult(text);
    }

    const getResult = async (value) => {
        if (mode === "encode") {
            try {
                const response = await ASCIIEncode({ input: value });
                setresult(response.data.bytes);
            } catch (error) {
                console.error("Error encoding ASCII:", error);
                setresult("Error encoding ASCII.");
            }
        } else {
            try {
                const response = await ASCIIDecode({ input: value });
                setresult(response.data.decoded);
            } catch (error) {
                console.error("Error decoding ASCII:", error.response?.data?.message);
                setresult(error.response?.data?.message || "Error decoding ASCII.");
            }
        }
    };

     const importFile = (fileContent) => {
        setText(fileContent);
    };

    const pasteExample = () => {
        let exampleValue = "";

        if (mode === "encode") {
            exampleValue = "<b>Hello World</b>";
        } else {
            exampleValue = "72 101 108 108 111";
        }

        setText(exampleValue);
    };

    return (
        <>
            <Col>
                <ToolHeader title="ASCII Bytes Converter" description="Convert ASCII text into byte values and back" toolFav={toolFav} />

                <ToolModeToggle
                    options={[
                        { label: "ASCII to Bytes", value: "encode", className: "encode" },
                        { label: "Bytes to ASCII", value: "decode", className: "decode" }
                    ]}
                    activeValue={mode}
                    onChange={setMode}
                />
                <Row className='Formatter json-formatter-row'>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title="Input"
                            value={text}
                            onChange={(e) => handleChange(e)}
                            placeholder={mode === "encode" ? "Paste text to encode.." : "Paste bytes to decode.."}
                            lineCount={lineCount}
                            headerButtons={
                                <InputHeaderButtons
                                    primaryLabel="Example"
                                    onPrimary={pasteExample}
                                    onClear={() => {
                                        setText("");
                                        setresult("");
                                    }}
                                    executeLabel={mode === "encode" ? "Encode" : "Decode"}
                                    showExecute={true}
                                    onExecute={Execute}
                                    onImport={(fileContent) => importFile(fileContent)}
                                />
                            }
                            footerLeft={`Characters : ${text.replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([text]).size} B`}
                        />
                    </Col>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title="Output"
                            value={result ?? ""}
                            placeholder="Output will appear here..."
                            lineCount={resultLineCount}
                            readOnly
                            headerButtons={
                                <OutputHeaderButtons
                                    outputText={result ?? ""}
                                    fileName={`${mode === "encode" ? "ascii-to-bytes" : "bytes-to-ascii"}.txt`}                                    mimeType="text/plain;charset=utf-8"
                                />
                            }
                            footerLeft={`Characters : ${result.replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([result ?? ""]).size} B`}
                        />
                    </Col>
                </Row>
            </Col >
        </>
    )
}

export default AsciiEncoder;
